import { useAuth } from '../contexts/AuthContext';
import { GoogleLogin } from '@react-oauth/google';

const Login = () => {
  const { handleGoogleLoginSuccess, handleLoginError } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md p-8 space-y-8 bg-card rounded-lg shadow">
        <div className="text-center">
          <h1 className="text-2xl font-bold">Central Auth Admin</h1>
          <p className="mt-2 text-muted-foreground">
            Sign in to manage services, groups, permissions, and users
          </p>
        </div>
        <div className="mt-8 flex justify-center">
          <GoogleLogin
            onSuccess={handleGoogleLoginSuccess}
            onError={handleLoginError}
            useOneTap
            auto_select
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
            logo_alignment="left"
          />
        </div>
      </div>
    </div>
  );
};

export default Login; 